import { Tooltip } from 'antd';

import { FinraTooltip, SecTooltip } from '../components/SecFinraDisclosure/SecFinraDisclosure';

export const NewTransfer = {
  Portfolio: 'portfolio',
  BalanceAndTransaction: 'balanceAndTransaction',
};

export const PROPERTY_TYPES = {
  INITIAL: 'initial',
  SECONDARY: 'secondary',
};
export const PROPERTY_TYPE_NAME = {
  [PROPERTY_TYPES.INITIAL]: 'Initial Offering',
  [PROPERTY_TYPES.SECONDARY]: 'Realbricks Market',
};

export const PROPERTY_SUB_TYPE = {
  VACATION: 'Vacation rental',
  SINGLE: 'Single family',
  MULTI: 'Multifamily',
};

export const RETURN_MODEL = {
  avg: 'average',
  low: 'lowest',
  high: 'highest',
};

// Single source of truth for the investment-range enum <-> display-label pairing, used both
// to render StepFour's radio options and to look up the display label on StepSix's review.
export const INVESTMENT_RANGE_OPTIONS = [
  { value: 'UNDER_500', label: 'Less than $500' },
  { value: 'RANGE_500_TO_2000', label: '$500 – $2,000' },
  { value: 'RANGE_2001_TO_10000', label: '$2,001 – $10,000' },
  { value: 'ABOVE_10000', label: '$10,000+' },
];

export const REALBRICKS_ADDRESS = 'Neptune REM, LLC 412 W Norfolk Ave STE 2, Norfolk, NE 68701'

export const TOOLTIP_TEXT = {
  POSITION_VALUE: 'The total amount you invested, based on the purchase price of your shares.',
  SMSUMMARY_POSITION_VALUE: 'The current value of the shares based on the latest available price. Updates in real time.',
  SMSUMMARY_PERCENT_RETURN: 'Shows the percentage change compared to the original share price. Updates once per day.',
  SUSUMMARY_DOLLAR_RETURN: 'Shows the total dollar gain or loss compared to the original share price. Updates once per day',
  PERCENT_RETURN: 'Shows your realized return, including gains or losses from completed sales and dividends received, expressed as a percentage of your original investment',
  DOLLAR_GAIN_LOSS: 'Shows your realized gain or loss in dollars, including completed sales and dividends received, excluding the amount of your original investment.',
  PURCHASE_PRICE:
    'The price paid by Realbricks to acquire the property. This does not include the offering fees or cash reserve, as applicable for the specific property.',
  PROPERTY_STATUS_RENTED: 'This property is currently rented.',
  PROPERTY_STATUS: 'This property is currently listed/marketed for rent on public rental sites including Zillow.',
  ESTIMATED_DIVIDEND_YIELD:'The estimated dividend yield represents the anticipated annual profit-sharing percentage for this property. Dividends are expected to be declared and paid on a quarterly basis, but are not guaranteed and may vary or not be paid. The yield is calculated by dividing the total anticipated annual dividend amount (to be shared among shareholders) by the property’s initial purchase price. The dividend you receive will be proportional to your ownership in the property.',
  PARTIAL_FILLS: `Allows your order to be filled partially rather than all at once. Filled shares are credited to your account as they clear, while any unfilled shares remain open until canceled. Once a partial fill occurs, the order cannot be edited, but the remaining open shares can be canceled at any time.`,
  FIRST_DIVIDEND_DATE:
    'The initial dividend date is the expected date for the first quarterly dividends. Any dividend payments are paid quarterly. Based on when the property was financed, there will be times when the first dividend payment will only cover a partial quarter.',
  FIRST_DIVIDEND_YIELD: `The annual dividend percentage is the estimated and anticipated profit-sharing amount to be paid by Realbricks to this property's investors. It is distributed on a quarterly basis and may vary. The annual dividend percentage is calculated by dividing the total anticipated dividend amount (to be shared among shareholders) by the initial property purchase price. The dividend you receive will be proportional to your ownership in the property`,
  RENTAL_DEMAND: `How often are rentals booked throughout the year? By using a combination of annual occupancy and listing growth rates, this metric shows the relative travel demand in the Realbricks market.

  High Score = High Travel Demand`,
  REVENUE_GROWTH: `Did properties earn more this month then they did in the same month last year? This is calculated by looking at the change in year-over-year RevPAR for properties that received bookings in both time periods.

  High Score = Increasing Revenue per Property`,
  SEASONALITY: `How much does travel demand differ between peak season and low season? This is the percentage difference between the minimum and maximum monthly RevPAR in the past year.

  High score = Low seasonality`,
  REGULATION: `An algorithm that looks at host and property behavior to identify signs of regulation.

  High score = Low regulation`,
  INVESTIBILITY: `Is this a good city for short-term rental investment property? Compares the cost of homes in the city to the average short-term rental income of full time rental properties.

  High score = Good Investment Opportunity`,
  MORTGAGE_AMOUNT:
    'The amount of the total expense funded by a long-term mortgage loan. To provide investors with leverage, mortgages are placed on the property.',
  MORTGAGE_INTREST_RATE: `The interest rate for the home loan used to obtain the property. The investors are not liable for the debt, as the loan is non-recourse. The rental income from the property covers the interest expenses.`,
  OFFERING_PURCHASE_PRICE: `The price paid to attain the property. Offering fees or cash reserve is not included.`,
  IMPROVEMENTS: `The amount of money set aside for property improvements and a cash reserve balance for maintaining long-term operations.`,
  CLOSING_OFFERING_HOLDING_COSTS: `These expenses include property closing costs, financing the property before or after closing, and offering the shares for investment.`,
  RB_SOURCING_FEE: `This is the fee Realbricks charges for our work associated with procuring the property and getting it ready for investment. This one-time fee is already included in the equity raised from investors and the share price.`,
  RB__AUM_QUARTER: `The Realbricks AUM fee is paid quarterly and based on an annual percentage of the property purchase price. This fee covers a range of services including tax preparation, investor support, financial oversight and overseeing the property management and is paid from the rental income.`,
  RB__AUM_MONTHLY: `The Property Management fees are paid monthly to the property management partner from the rental income and helps cover the operational expenses of the rental unit. Competitive rates are negotiated with our property management partners for each individual offering.`,
  RECURRING_FEE_NOTE: `Note: Shareholders will not be invoiced for these fees; the fees will be deducted from the rental revenue.`,
  PROPERTY_MANAGEMENT_FEES: `Property Management Fees are paid monthly to the property management partner from the rental income and helps cover the operational expenses of the rental unit. Competitive rates are negotiated with our property management partners for each individual offering.`,
  AVERAGE_TIME_TO_RENT: `The amount of time required to sign the first tenant lease varies depending upon several factors including seasonality and whether or not the property is in need of any sort of renovation. Generally, the average time to lease is around 45 days and has ranged from a minimum of 7 days to over 90 days.`,
  OCCUPANCY_RATE: `The occupancy rate is the ratio of used or rented space to the total amount of available space.`,
  PRIMARY_DURATION:`The duration of an order for an initial offering will last until the property’s funding period concludes.`,
  HISTORICAL_PERFORMANCE: (location) =>
    `Based on data provided by independent, third-party data providers, including Zillow and/or HouseCanary the Historical Performance is the estimated annual average property appreciation over the last 10 & 20 years for the ${location} Realbricks market.`,
  ACCOUNT_VALUE_DESCRIPTION: 'Total Account Value is the combined value of your investments, based on their purchase price, and your total wallet balance.',
  ACCOUNT_VALUE_FOOTNOTE: (
    <>
      <b>Total Account Value</b> and <b>All-Time Gain</b> include all shares at their purchase price. Share values are not adjusted until a sale or
      qualifying liquidity event occurs.
    </>
  ),
  PARTIALLY_MATCHED_PROCESSING_CANCEL:
    'Your order is partially matched and processing, so it can’t be cancelled yet. You can cancel the remaining shares once processing is complete.',
  PARTIALLY_MATCHED_PROCESSING_EDIT:
    'Your order is partially matched and processing, so it can’t be edited yet. You can edit the remaining shares once processing is complete.',
  PENDING_MATCHED_TRADE_CANCEL: 'Your order has been matched and is being processed. It can no longer be cancelled.',
  PENDING_MATCHED_TRADE_EDIT: 'Your order has been matched and is being processed. It can no longer be edited.',
};

export const PIN_VERIFICATION_TYPES = {
  LOGIN: 'login',
  MARKET_PLACE: 'marketPlace',
  PROFILE_EDIT: 'profileEdit',
};

export const NOTIFICATION_MESSAGES = {
  PLAID_LINK_ACCOUNT_ERROR:
    'We are currently experiencing an issue linking your bank account via Plaid. Please ensure you have checked all the required boxes during the bank addition process and try again later. If the problem persists, please contact support@realbricks.com team for assistance.',
};

const SUPPORT_EMAIL = 'support@realbricks.com';
const SupportEmailLink = () => <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>;

export const WARN_DWOLLA_PENDING = (
  <>
    Your account is in review, please contact{" "}
    <SupportEmailLink /> for assistance.
  </>
);

export const ERROR_BALANCE_BANK_MESSAGE = (
  <>
    Your account has been temporarily frozen due to multiple unsuccessful funding attempts.Please contact{" "}
    <SupportEmailLink /> for assistance.
  </>
);

export const ERROR_CONNECTIONG_BANK_MESSAGE = (
  <>
    Error connecting bank account, please contact{" "}
    <SupportEmailLink />
  </>
);

export const ACCOUNT_FREEZE_ERROR_MESSAGE = (
  <>
  Your account has been temporarily frozen. Please contact <SupportEmailLink /> for additional information.
  </>
)

export const KYC_NOT_VERIFIED_MESSAGE = (
  <>
    Your account is not fully verified. Please contact{' '}
    <SupportEmailLink /> for assistance.
  </>
);

export const ENTITY_SECONDARY_MARKET_MESSAGE =
  'Entity accounts cannot buy or sell shares on the Secondary Marketplace at this time.';

export const ENTITY_INFORMATION_KYB_APPROVED_MESSAGE = (
  <>
    Your entity information has been verified and can no longer be edited. If you need to make any changes, please contact <SupportEmailLink />.
  </>
);

export const ENTITY_ADDRESS_KYB_APPROVED_MESSAGE = (
  <>
    Your entity address has been verified and can no longer be edited. If you need to make any changes, please contact <SupportEmailLink />.
  </>
);

export const RESIDENTIAL_ADDRESS_DESCRIPTION = 'Please provide your residential address that will be used for account verification.';

export const ENTITY_ADDRESS_DESCRIPTION = "Please provide your entity's legal address as it appears on official documents.";

// Entity/Trust accounts must invest at least this much (in dollars) per initial-offering
// purchase order, regardless of the per-property minimum the backend returns.
export const ENTITY_MINIMUM_INITIAL_INVESTMENT = 1000;
/**
 * Returns true when the user has completed all onboarding steps:
 * - All 5 verifiedAgreementDocs are true
 * - dwollaAgreementsSigned is true
 * - counter === 5
 */
export const checkOnboardingComplete = (userDataObj, counter) => {
  const verifiedAgreementDocs = userDataObj?.verifiedAgreementDocs;
  const dwollaAgreementsSigned = userDataObj?.dwollaAgreementsSigned;
  return (
    counter === 5 &&
    dwollaAgreementsSigned === true &&
    verifiedAgreementDocs != null &&
    Object.keys(verifiedAgreementDocs).length === 5 &&
    Object.values(verifiedAgreementDocs).every((v) => v === true)
  );
};

const handleClickHereKeyDown = (callback) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback(e);
  }
};

export const AML_DOCUMENT_PENDING = ({ navigate, onOpenModal }) => {
  const handleClick = () => (onOpenModal ? onOpenModal() : navigate('/sign-up/verification'));
  return (
      <>
        Please complete document upload for identity verification.{' '}
      <span
        style={{ color: '#8a4743', cursor: 'pointer' }}
        role='button'
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleClickHereKeyDown(handleClick)}
      >
        Click here
      </span>
    </>
  );
};

export const COMPLETE_VERIFICATION_FIRST = ({ navigate }) => {
  const handleClick = () => navigate('/sign-up/verification');
  return (
    <>
      Please complete all your verification steps first.{" "}
      <span
        style={{color:'#8a4743',cursor: 'pointer'}}
        role='button'
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleClickHereKeyDown(handleClick)}
      >
        Click here
      </span>
    </>
  );
};

export const MobileDeviceDetect = {
  MOBILE_DEVICE_DETECT : process.env.REACT_APP_MOBILE_DETECT_URL,
  MOBILE_REDIRECTION_LOGIN_BUTTON : process.env.REACT_APP_MOBILE_REDIRECTION_LOGIN_BUTTON_URL,
  MOBILE_REDIRECTION_SIGNUP_BUTTON: process.env.REACT_APP_MOBILE_REDIRECTION_SIGNUP_BUTTON_URL,
}

export const BonusAmount = {
  REFERRAL_BONUS_AMOUNT : 50,
}

export const DWOLLA_LINKS_POLICY_LINK = {
  PRIVACY_POLICY: 'https://www.dwolla.com/legal/privacy',
  TERMS_AND_CONDITIONS: 'https://www.dwolla.com/legal/tos'
};

export const BRANCHIO_FEATURE_NAME = {
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  REDIRECT_INTENDED_PAGE: 'redirect_intended_page',
  HOMEPAGE: 'homepage',
}

export const BRANCHIO_REDIRECTION_PATH_NAME = {
  LOGIN: '/login',
  SIGN_UP_AUTH: '/sign-upAuth',
  REDIRECT_INTENDED_PAGE: '/redirect-intended-page',
  HOMEPAGE: '/',
}

export const PRIMARY_BUTTON_BUY = ['New', 'Trending', 'Nearly Funded', '25% Funded', '50% Funded', '75% Funded', '90% Funded', 'Closing Soon', null, undefined,]

export const GHOST_NOTIFY = ['Coming Soon', 'Fully Funded',]

export const NOT_SHOWING_CALL_OPTIPN = ['Funded', 'Closed', 'Next Investment Window: December','Coming Soon', 'Fully Funded',]

export const PRIMARY_PROPERTY_LABELS = {
  SHARE_PRICE: 'Share Price',
}

export const BUILD_VERSION = 'V 4.73';

export const TRANSACTION_VALIDATION_MESSAGES = {
  MIN_AMOUNT: 'Please note that the minimum transaction amount is $10. Adjust number of shares or limit price to proceed.',
  MAX_AMOUNT: 'Please note that the maximum transaction amount is $10,000. Adjust number of shares or limit price to proceed.',
  INVALID_SHARE_NUMBER_BUY: 'Please enter at least 1 share to continue.',
  INVALID_SHARE_NUMBER_SELL: 'Please enter at least 1 share to sell.',
  INVALID_PRICE_FORMAT: 'Please enter a number greater than 0 and upto 2 decimal places.',
};

export const PIN_SECURITY_DESCRIPTION =
  'This PIN will be used as a security measure to prevent unauthorized access to your account and for you to easily log in.';

export const PIN_SECURITY_DESCRIPTION_WITH_WARNING = `${PIN_SECURITY_DESCRIPTION} Do not share your 4-digit PIN with anyone under any circumstances.`;

const SET_UP_ACCOUNT_TITLE = 'Set up your account';

const INVESTMENT_ACCOUNT_DESCRIPTION = (
  <>
    <p>
      Let’s get your{' '}
      <Tooltip
        placement='bottom'
        title='An investment account holds your financial assets (cash and property shares) on your behalf. Realbricks does not charge any fee on these accounts, nor does it offer any annual percentage yield. They are subject to ordinary income tax rates and capital gains taxes.'
      >
        <span className='underline cursor-pointer'>investment account</span>
      </Tooltip>{' '}
      set up so that you can begin investing on Realbricks.
    </p>
    <p>
      The securities issued via the Realbricks platform are regulated under <SecTooltip />, <FinraTooltip />, and State law; Realbricks and its
      broker-dealer partner conduct identity verification and related compliance checks required for investor onboarding.
    </p>
  </>
);

// Sidebar (info) and form title/description text for each onboarding Verification step.
export const VERIFICATION_STEP_CONTENT = {
  StepOne: {
    infoTitle: SET_UP_ACCOUNT_TITLE,
    infoDescription: INVESTMENT_ACCOUNT_DESCRIPTION,
    formTitle: 'Verify your identity',
  },
  EntityDocs: {
    infoTitle: SET_UP_ACCOUNT_TITLE,
    infoDescription: INVESTMENT_ACCOUNT_DESCRIPTION,
    formTitle: 'Entity documentation',
  },
  StepTwo: {
    infoTitle: SET_UP_ACCOUNT_TITLE,
    infoDescription: INVESTMENT_ACCOUNT_DESCRIPTION,
    formTitle: 'Provide your contact information',
  },
  StepThree: {
    infoTitle: SET_UP_ACCOUNT_TITLE,
    infoDescription: INVESTMENT_ACCOUNT_DESCRIPTION,
    formTitle: 'Provide your contact information',
    formDescription:
      'We are required by federal law to verify your identity. We will use your information for tax reporting. Your information is encrypted and secure.',
  },
  StepFour: {
    infoTitle: 'Your investment preferences',
    infoDescription: 'Tell us how much you’d like to invest so we can guide you to the right properties.',
  },
  UploadID: {
    infoTitle: 'Upload ID',
    infoDescription: INVESTMENT_ACCOUNT_DESCRIPTION,
    formTitle: 'ID Upload Required',
  },
  StepSix: {
    infoTitle: 'Review your information',
    infoDescription:
      'Please take a moment to ensure all your information has been entered correctly before opening your investment account with Realbricks.',
  },
};
